import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { client } from '../../../utils'
import { routePaths } from '../../urls'
import StatusMarker from '../StatusMarker'

class BrightspaceTest extends React.Component {
  static contextTypes = {
    store: PropTypes.object,
  }

  state = {
    testing: false,
    passed: false,
    error: false,
  }

  componentDidMount() {
    this.unsubscribe = this.context.store.subscribe(() => {
      this.forceUpdate()
    })
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  runTest = async () => {
    this.setState({
      testing: true,
      passed: false,
      error: false,
    })
    let { coursenum } = this.context.store.getState()
    let url = `/links/client_brightspace.test/${coursenum}/`
    try {
      var resp = await client.get(url)
    } catch (e) {
      console.error(`Error requesting ${url}`, e)
      return this.setState({
        testing: false,
        error: true,
      })
    }
    let success = resp.data.success
    this.setState({
      testing: false,
      passed: success,
      error: !success,
    })
  }

  render() {
    let buttonText = this.state.testing ? 'Testing...' : 'Test Integration'
    let alert = this.state.error ? (
      <div className="alert alert-danger">Test Failed</div>
    ) : this.state.passed ? (
      <div className="alert alert-success">
        Test passed! Everything is working as expected.
      </div>
    ) : null
    let testIcon = this.state.error
      ? 'icon_warning'
      : this.state.passed
      ? 'icon_checkmark'
      : 'icon_notification'

    return (
      <div>
        <div className="canvas-flex-wrapper">
          <div className="canvas-form-container">
            <h2>Test Brightspace Integration</h2>
            {alert}
            <p>
              Use this tool to test the Brightspace integration. If there are
              any issues, you may need to go back to the previous step and
              re-authenticate your account.
            </p>
            <p>
              If you&apos;re experiencing issues with the Brightspace
              integration, please contact our support team at &nbsp;
              <a href="mailto:support@myeducator.com">support@myeducator.com</a>
              .
            </p>
            <Link
              to={routePaths.brightspaceAssessments}
              className="btn btn-myed btn-default btn-default-myed"
            >
              Back
            </Link>
            <button
              className="btn btn-myed btn-primary btn-primary-myed"
              disabled={this.state.testing}
              onClick={this.runTest}
            >
              {buttonText}
            </button>
          </div>
          <div className="canvas-statusmarker-container">
            <StatusMarker iconType={testIcon} />
          </div>
        </div>
      </div>
    )
  }
}

export default BrightspaceTest
